import Agent from "infrastructure/agent";

const getFacilities = () => Agent.get(`/facility`);

export default {
  getFacilities,
};
